/* Hauser MX — carga diferida del mini mapa de la ficha (Fase 8).
 *
 * Un iframe de Google Maps arrastra su propio motor de mapas: es, con
 * diferencia, el recurso más pesado de la ficha de propiedad. Y casi siempre
 * queda por debajo del pliegue. Cargarlo de entrada sería regalar medio
 * segundo de LCP a cambio de nada.
 *
 * Aquí el `src` real espera en `data-hauser-mapa-src` y solo se aplica cuando
 * el bloque está a punto de entrar en pantalla. Mientras tanto se ve un marco
 * con la identidad del sitio, no un hueco gris.
 *
 * Funciona en los tres niveles del motor, incluido `flat`: esto no es un
 * efecto, es contenido — y el mapa fue un pedido explícito del dueño. Lo único
 * que cambia es que sin IntersectionObserver se carga de inmediato.
 */
(function () {
  'use strict';

  var bloques = document.querySelectorAll('[data-hauser-mapa]');
  if (!bloques.length) return;

  var H = window.Hauser;

  function cargar(bloque) {
    var iframe = bloque.querySelector('[data-hauser-mapa-src]');
    if (!iframe || iframe.getAttribute('src')) return;

    var cargando = bloque.querySelector('[data-hauser-mapa-cargando]');

    iframe.addEventListener(
      'load',
      function () {
        bloque.setAttribute('data-hauser-mapa-listo', '');
      },
      { once: true }
    );

    /* Si el mapa no llega en 8 segundos (red mala, o Google bloqueando el
       embed) se retira el indicador y se deja el marco limpio con la nota de
       zona debajo. Nunca un "Cargando…" eterno, que es peor que no tenerlo. */
    setTimeout(function () {
      if (!bloque.hasAttribute('data-hauser-mapa-listo')) {
        bloque.setAttribute('data-hauser-mapa-fallo', '');
        if (cargando) cargando.hidden = true;
      }
    }, 8000);

    iframe.setAttribute('src', iframe.getAttribute('data-hauser-mapa-src'));
  }

  Array.prototype.forEach.call(bloques, function (bloque) {
    if (H && H.enVista) {
      /* 300px de margen: arranca la carga justo antes de que se vea, para que
         llegue ya pintado y no aparezca a medias. */
      H.enVista(bloque, function () { cargar(bloque); }, { rootMargin: '300px 0px' });
    } else {
      cargar(bloque);
    }
  });
})();
